<template>
  <div id="app">
    <el-row>
      <el-col :span="20">
Passo 5 - PROPOSTA COMERCIAL

      </el-col>
    </el-row>

    
  </div>
</template>

<script>

export default {
  
  
};
</script>

